import { ref, computed, toRaw } from "vue";
import { defineStore } from "pinia";

import Vue from 'vue'

interface ITaskRecord {
  uniqueId: string;
  type: string;
  description: string;
  id: number;
  sourceId: number;
  containerId: number;
}

interface IState {
  taskRecords: ITaskRecordsMap;
  labtaskRecords: ITaskRecordsMap;
  labTasks: [];
  labPanels: [];
}

interface ITaskRecordsMap {
  [taskRecordsSource: string]: ITaskRecord[];
}

interface ITasksPayload {
  sourceId: number;
  tasks: ITaskRecord[];
}

const taskRecords: ITaskRecordsMap = {};
const labtaskRecords: ITaskRecordsMap = {};

const state: IState = {
  taskRecords,
  labtaskRecords,
  labTasks: [],
  labPanels: [],
};

const uniqueId = (payload: ITaskRecord) => `${payload.sourceId}-${payload.id}`;

export const useStoreTaskBuilder = defineStore("taskBuilderStore", {
  state: () => {
    return {
      products: ["1", "apple", "fruit"],
      taskRecords,
      labtaskRecords,
      labTasks: [],
      labPanels: [],
    }
  },
  getters: {
    // getTaskRecordsForSource: (state: IState) => (sourceId: number) => {
    //   // // console.log('TASK Store :         getTaskRecordsForSource  sourceId:', sourceId)
    //   return state.taskRecords[sourceId] || []
    // },
    getAllTaskRecords: (state: IState)  => {
      // // // console.clear()
          // // console.log('TASK Store :         getAllTaskRecords TODO Flat')
          // // console.dir(state.taskRecords)
          // // console.log('  TO  FLAT > >')
          // // console.dir(Object.values(state.taskRecords).flat())

      return Object.values(state.taskRecords).flat();
    },
    getTaskRecordsForSource: (state) => {
      return (sourceId) => state.taskRecords[sourceId]
    },
    getLabPanels:  (state: IState) => {
      // // console.log('    <<<<<<<<<<<<<<<<<<<<<<<<<<<<<   GETTING  PATIENT STORE > get Lab Panels ')
      return state.labPanels
    },
    getLabTaskRecordsForSource: (state: IState) => (sourceId: number) => {
      return state.labtaskRecords[sourceId] || []
    },
    getAllLabTaskRecords: (state: IState) => {
      return Object.values(state.labtaskRecords).flat()
    }
  },
  actions: {
    // addProduct() {
    //   this.products.push();
    // },

    setPatientLabPanels(sourceId) {
      // // console.log("    >>>>>>>>>>>>>>>>>>>>>>>>>>>>   SETTING  PATIENT STORE > set Lab Panels ");
      this.labPanels = sourceId;

      // // console.log(' vue3 NEW sub for Vue.delete')

      delete this.labPanels[sourceId]

      // Vue.set(state.labPanels, state.labPanels, payload)
      // this.labPanels = payload

    },
    clearPatientTaskRecordsBySourceId(sourceId) {
      // // console.log("   Task Build store                                                  clearPatientTaskRecordsBySourceId ................");

      // // console.log("SourceId: " + sourceId);

      // state.taskRecords.filter(x => x === sourceId)

      // Vue.delete(state.taskRecords, sourceId);
      delete this.taskRecords[sourceId]


      // // console.log(".....CHECKING ..........      state.taskRecords");
      // // console.dir(state.taskRecords);
    },

      // still have to do this Vue.set/Vue.delete business
  addTaskRecords( payload: ITasksPayload) {
    // // console.log('                                                        *** taskBuilder Store   addTaskRecords')
    // // // console.log('state: ', state)
    // // console.log('payload: ', payload)

    //! REMOVED 02-03
    // this.addTask(state,payload)

    if (!payload.tasks || payload.tasks.length === 0) {
      // Vue.delete(state.taskRecords, payload.sourceId)
      delete this.taskRecords[payload.sourceId]

    }
    // Vue.set(state.taskRecords, payload.sourceId, payload.tasks)
    this.taskRecords[payload.sourceId] = payload.tasks

  },

  addLabTaskRecords(payload: ITasksPayload) {

    // // console.log('______________________________________________')
    // // console.log('__________labs STORE ____  addLabTaskRecords')
    // // console.log('     state: ', state)
    // // console.log('     payload: ', payload)


    if (!payload.tasks || payload.tasks.length === 0) {
      // Vue.delete(state.taskRecords, payload.sourceId)
      delete this.labtaskRecords[payload.sourceId]
    }
    // Vue.set(state.taskRecords, payload.sourceId, payload.tasks)
    this.labtaskRecords[payload.sourceId] = payload.tasks
  },

  addTask(task) {
    // // console.log('             >>>>        *** taskBuilder Store   addTask')
    // // // console.log('state: ', state)
    // // console.log('task: ', task)

    // mutate state
    this.labTasks.push(task)
  },
  // setPatientLabPanels(state, payload) {
  //   // // // console.log('    >>>>>>>>>>>>>>>>>>>>>>>>>>>>   SETTING  PATIENT STORE > set Lab Panels ')
  //   state.labPanels = payload

  //   // // // // console.log('  P store   Vue.set(state.labPanels, state.labPanels, payload)')
  //   // Vue.set(state.labPanels, state.labPanels, payload)
  // },
  clearPatientTaskRecords(state){
    state.taskRecords = {}
    // // // console.log('   Task Build store  CLEAring task records OBJECT ................')
    // // console.dir(state.taskRecords)
  },
  // clearPatientTaskRecordsBySourceId(state, sourceId){
  //   // // console.log('   Task Build store                                                  clearPatientTaskRecordsBySourceId ................')

  //   // // console.log('SourceId: ' + sourceId)

  //   Vue.delete(state.taskRecords, sourceId)
  //   // // console.log('.....CHECKING ..........      state.taskRecords')
  //   // // console.dir(state.taskRecords)
  // },


  },
});

